import React, { useState, useEffect, useCallback } from 'react';
import './../../core/style/HeroSlider.css';
import { sliderData } from './../../Data/inventoryProvider';

const HeroSlider = () => {
  const [current, setCurrent] = useState(0);
  const length = sliderData.length;

  const nextSlide = useCallback(() => {
    setCurrent((prev) => (prev === length - 1 ? 0 : prev + 1));
  }, [length]);

  const prevSlide = () => {
    setCurrent((prev) => (prev === 0 ? length - 1 : prev - 1));
  };

  useEffect(() => {
    const timer = setInterval(nextSlide, 8000); 
    return () => clearInterval(timer);
  }, [nextSlide]);

  return (
    <section className="busan-hero" id='help'>
      {sliderData.map((slide, index) => (
        <div
          className={index === current ? 'slide active' : 'slide'}
          key={slide.id}
        >
          {index === current && (
            <>
              <div
                className="slide-bg"
                style={{ backgroundImage: `url(${slide.image})` }}
              >
                <div className="slide-overlay"></div>
              </div>

              <div className="slide-content">
                <span className="slide-number">0{index + 1}</span>
                <h3 className="slide-subtitle">{slide.subtitle}</h3>
                <h1 className="slide-title">{slide.title}</h1>

                <div className="guide-text-wrapper">
                  <p className="slide-desc english-text">{slide.description}</p>
                  <div className="text-divider"></div>
                  <p className="slide-desc hindi-text">{slide.descriptionHindi}</p>
                </div>
                {/*                 
                <div className="slide-actions">
                  <button className="btn-primary" onClick={() => window.location.href='#guidance'}>
                    Watch Video Guide
                  </button>
                  <button className="btn-outline">Download PDF Guide</button>
                </div> */}
              </div>
            </>
          )}
        </div>
      ))}

      <div className="slider-nav">
        <button className="nav-btn prev" onClick={prevSlide}>
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
            <path d="M19 12H5M5 12L12 19M5 12L12 5" />
          </svg>
        </button>
        <button className="nav-btn next" onClick={nextSlide}>
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
            <path d="M5 12H19M19 12L12 5M19 12L12 19" />
          </svg>
        </button>
      </div>

      <div className="slider-dots">
        {sliderData.map((_, idx) => (
          <div
            key={idx}
            className={idx === current ? 'dot active' : 'dot'}
            onClick={() => setCurrent(idx)}
          ></div>
        ))}
      </div>
    </section>
  );
};

export default HeroSlider;